module.exports = __webpack_public_path__ + "static/media/tf.df661c75.png";